var staticStrFirst = 'first'

module.exports = staticStrFirst



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/static/staticStrFirst.js
// module id = 117
// module chunks = 106